module.exports = __webpack_public_path__ + "static/media/azentio.jpg.d4090850.sb-3a783778-Jn0SEv";